<script>

/**
 * Nav-bar Component
 */
export default {
  components: {},
  props: {
    location: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {};
  },
  methods: {
    formatAddress(item) {
      let addressFull = '';

      if (item.street !== '')
        addressFull += (addressFull !== '' ? ', ' : '') + item.street;

      if (item.commune && item.commune.name !== '') {
        addressFull += (addressFull !== '' ? ', ' : '') + item.commune.name;
      }

      if (item.country && item.country.name !== '' && item.country.name !== 'France') {
        addressFull += (addressFull !== '' ? ', ' : '') + item.country.name;
      }

      return addressFull;
    }
  }
};
</script>

<template>
  <b-card no-body class="text-center">
    <b-card-body>
      <h5 class="font-size-15 mb-1">
        <span class="text-dark">{{ location.name }}</span>
      </h5>

      <p class="text-muted"> {{ formatAddress(location) }}</p>

    </b-card-body>
  </b-card>
</template>
